import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "input" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "id", "value", "required", "placeholder", "disabled", "maxlength"]
const _hoisted_4 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["field", [{ isLabelAtop: _ctx.isLabelAtop, hasLabel: _ctx.label, isDisabled: _ctx.disabled }]])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.inputId
          }, _toDisplayString(_ctx.label), 9, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("textarea", {
        ref: "textarea",
        rows: "4",
        name: _ctx.inputName,
        id: _ctx.inputId,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => {
          _ctx.isFocused = false;
          _ctx.$emit('blur');
        }),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputEvent && _ctx.inputEvent(...args))),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        value: _ctx.modelValue,
        required: _ctx.required,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        maxlength: _ctx.maxlength
      }, null, 40, _hoisted_3)
    ], 2),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ]))
}